import { trackDashboardSessionEnded } from './eventTracking';

class SessionTracker {
  private sessionStartTime: number | null = null;
  private inactivityTimer: NodeJS.Timeout | null = null;
  private isSessionActive = false;
  private activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

  startSession() {
    if (this.isSessionActive) return;
    
    this.sessionStartTime = Date.now();
    this.isSessionActive = true;
    this.setupInactivityTimer();
    this.setupActivityListeners();
    this.setupBeforeUnloadListener();
  }

  endSession() {
    if (!this.isSessionActive || !this.sessionStartTime) return;
    
    const sessionDuration = Date.now() - this.sessionStartTime;
    trackDashboardSessionEnded(sessionDuration);
    
    this.cleanup();
  }

  private setupInactivityTimer() {
    this.resetInactivityTimer();
  }

  private resetInactivityTimer() {
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }
    
    if (this.isSessionActive) {
      this.inactivityTimer = setTimeout(() => {
        if (this.isSessionActive) {
          this.endSession();
        }
      }, 5 * 60 * 1000); // 5 minutes
    }
  }

  private setupActivityListeners() {
    this.activityEvents.forEach(event => {
      document.addEventListener(event, () => this.resetInactivityTimer(), true);
    });
  }

  private setupBeforeUnloadListener() {
    const handleBeforeUnload = () => {
      this.endSession();
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
  }

  private cleanup() {
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = null;
    }
    
    this.activityEvents.forEach(event => {
      document.removeEventListener(event, () => this.resetInactivityTimer(), true);
    });
    
    this.isSessionActive = false;
    this.sessionStartTime = null;
  }
}

// Export singleton instance
export const sessionTracker = new SessionTracker();
